import {
  Box,
  TextField,
  Chip,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface TagInputProps {
  field: string;
  label: string;
  color: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info';
  tags: string[];
  inputValue: string;
  onInputChange: (field: string, value: string) => void;
  onTagAdd: (field: string) => void;
  onTagRemove: (field: string, index: number) => void;
  onKeyPress: (field: string, event: React.KeyboardEvent) => void;
  required?: boolean;
  showError?: boolean;
  errorText?: string;
  maxTags?: number;
}

const TagInput: React.FC<TagInputProps> = ({ 
  field, 
  label, 
  color, 
  tags, 
  inputValue, 
  onInputChange, 
  onTagRemove, 
  onKeyPress,
  showError,
  errorText,
  maxTags = 5
}) => {
  const { t } = useTranslation('profile');
  const isMaxReached = tags.length >= maxTags;
  
  return (
    <Box>
      <TextField
        fullWidth
        label={label}
        value={inputValue}
        onChange={(e) => onInputChange(field, e.target.value)}
        onKeyPress={(e) => onKeyPress(field, e)}
        disabled={isMaxReached}
        error={!!(typeof showError !== 'undefined' && showError)}
        helperText={
          (typeof showError !== 'undefined' && showError && errorText)
            || (isMaxReached ? t('businessProfile.productsServices.maxTags', { max: maxTags }) : t('businessProfile.productsServices.pressEnter'))
        }
        size="small"
        sx={{ mb: 1 }}
      />
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {tags
          .map((tag, index) => ({ tag, index })) // Preserve original index
          .filter(({ tag }) => tag && tag.trim()) // Filter out empty tags
          .map(({ tag, index }) => (
            <Chip
              key={`${field}-${index}`}
              label={tag}
              color={color}
              onDelete={() => onTagRemove(field, index)}
              size="small"
            />
          ))}
      </Stack>
    </Box>
  );
};

export default TagInput;
